import React, { useContext } from 'react'
import { Box, Button } from '@mui/material'
import { WizardContext } from './WizardContext'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const WizardFooter = ({
  backButton = {},
  skipButton = {},
  primaryButton = {},
  hideBackButton = false,
  hideSkipButton = false,
}) => {
  const { navigateToNext, navigateToPrevious } = useContext(WizardContext)

  const getBackButton = () => {
    if (hideBackButton) return null
    const { label, onClick, ...props } = {
      label: 'Back',
      onClick: navigateToPrevious,
      ...backButton,
    }

    return (
      <Button startIcon={<ChevronLeft />} onClick={onClick} {...props}>
        {label}
      </Button>
    )
  }

  const getSkipButton = () => {
    if (hideSkipButton) return null
    const { label, onClick, ...props } = {
      label: 'Skip',
      onClick: navigateToNext,
      ...skipButton,
    }

    return (
      <Button onClick={onClick} {...props}>
        {label}
      </Button>
    )
  }

  const getPrimaryButton = () => {
    const { label, onClick, ...props } = {
      label: 'Next',
      onClick: navigateToNext,
      ...primaryButton,
    }
    return (
      <Button
        endIcon={<ChevronRight />}
        sx={{ ml: 1 }}
        variant={'contained'}
        onClick={onClick}
        {...props}
      >
        {label}
      </Button>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        mt: 4,
      }}
    >
      <Box>{getBackButton()}</Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        {getSkipButton()}
        {getPrimaryButton()}
      </Box>
    </Box>
  )
}

export default WizardFooter
